import { SelectOption } from "@acin.reactjs/acin-ui/select";
import format from "date-fns/format";
import { Column, RowSignature } from "@acin.reactjs/acin-ui/table";
import { t } from "i18next";
import { internalDateFormat } from "../constants/AppConstants";

export const formatDate = (
  date: Date,
  formatString: string = internalDateFormat,
): string => {
  if (!date) return "-";
  return format(date, formatString);
};

export const parseAmount = (amount: number | string | undefined) =>
  new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
  }).format(parseFloat((amount ?? 0).toString().replace(",", ".")));

export const parseDate = (dateString: string): Date => {
  const parsedDate = new Date(dateString);
  if (Number.isNaN(parsedDate.getTime())) throw new Error("Invalid date");
  return parsedDate;
};

export const hexToRgba = (hex: string, alpha: number): string => {
  const [r, g, b] = hex.match(/\w\w/g)!.map((x) => parseInt(x, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const parsePercentage = (
  value: string | undefined | number,
  decimals = 0,
): string =>
  value !== undefined && value !== null && value !== ""
    ? `${parseFloat(value.toString()).toFixed(decimals).replace(".", ",")}%`
    : "-";

export const parsedSelectOption = (
  select: SelectOption<Record<string, unknown>, string> | null,
) => (typeof select === "object" && select ? select?.value : undefined);

export const renderStatusBoolean = <T extends RowSignature<T>>(
  ...[value]: Parameters<NonNullable<Column<T>["render"]>>
) => (value ? t("common.active") : t("common.inactive"));

export const containsHtml = (str: string): boolean => {
  const div = document.createElement("div");
  div.innerHTML = str;
  return Array.from(div.childNodes).some(
    (node) => node.nodeType === 1 || node.nodeType === 3,
  );
};

export const formatAmountForReadOnly = (
  amount: number | string | undefined,
) => {
  if (amount == null) return "";

  const num = parseFloat(amount.toString().replace(",", "."));

  const [integerPart, decimalPart] = num.toFixed(2).split(".");

  const integerWithThousands = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ".",
  );

  return `${integerWithThousands},${decimalPart} €`;
};

export const truncateText = (text?: string, max = 40) => {
  if (!text) return "";
  return text.length > max ? `${text.slice(0, max)}...` : text;
};
